import { useController, type Control, type FieldPath, type FieldValues } from 'react-hook-form'
import { Switch, type SwitchProps } from '@/components/ui/Switch'

export interface FormSwitchProps<TFieldValues extends FieldValues>
  extends Omit<SwitchProps, 'isSelected' | 'onChange'> {
  control: Control<TFieldValues>
  name: FieldPath<TFieldValues>
}

/**
 * FormSwitch - A React Hook Form integrated switch component.
 *
 * Uses useController to properly integrate with the form's control prop.
 */
export function FormSwitch<TFieldValues extends FieldValues>({
  control,
  name,
  ...props
}: FormSwitchProps<TFieldValues>) {
  const { field } = useController({
    control,
    name,
  })

  return <Switch {...props} isSelected={!!field.value} onChange={field.onChange} />
}

export default FormSwitch
